import type { ApiKey } from '@interfaces/apiKey';

/**
 * What to call a key in a sentence.
 *
 * `name` is nullable on the API's list response — `meta.name` is what we write,
 * but only Unkey's own `name` survives a key edited in its console, and either
 * can be absent. Every place that quotes a key in prose needs the same answer,
 * and `Revoke “null”?` is the failure this exists to prevent.
 */
export function keyLabel(key: Pick<ApiKey, 'name' | 'prefix'>): string {
  return key.name ?? `${key.prefix}…`;
}
